(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripDeleteController', FleetDailyTripDeleteController);

    FleetDailyTripDeleteController.$inject = ['$uibModalInstance', 'entity', 'FleetDailyTrip'];

    function FleetDailyTripDeleteController($uibModalInstance, entity, FleetDailyTrip) {
        var vm = this;

        vm.fleetDailyTrip = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FleetDailyTrip.delete({id: id}, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
